import { Component, Inject, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-add-product-crousel-cust',
  templateUrl: 'add-product-crousel-cust.component.html',
  styleUrls: ['./add-product-crousel-cust.component.scss']
})
export class AddProductCrouselCustComponent implements OnInit {
  loaded: boolean = true;
  imgUrl = environment.ImageUrl;
  @Input() images: string[] = ['Banner_marketplace_2.jpg'];
  @Input() local: boolean = true;
  @Input() design: string = '0';
  @Input() item: any = {
    0: {
      items: 1
    },
  };

  carouselOptions: any = {
    pagination: false,
  };
  constructor(@Inject('WINDOW') private window) { }
  ngOnInit(): void {
    this.carouselOptions.responsive = this.item;
  }

  redirectLink(url: string) {
    if (!url) return false
    if (!this.local) {
      this.window.open('http://' + url, "_blank")
    }
  }
  getImageSrc(local: boolean, image: any): string {
    if (local) {
      return '../../../../assets/images/new/' + image;
    }
    return this.imgUrl + (image?.image || '');
  }
  loadImg() {
    if (this.loaded) {
      // setTimeout(()=>{
      this.loaded = false
      // }, 500)
    }
  }
}
